
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gSdBODlygOCNExugHsxpEANS5HwjCrJSNdupAeJEuTvoMeta } from "/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexKTc7rAaGJHf31HpXeAcMtYMSpL9YeEPXxfL75s0R_54Meta } from "/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchNDdWkM_45xKbS6oKdOe3eYFSFMvV8TRrjhMWbTsAlLhpUMeta } from "/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexP3qksAgko5ItoNvAnkoqXdZyXH75uSPp_45_45kr1ei_456hEMeta } from "/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_937dMdu2pnb6izNh75w2TmNDjDVYZQ3JmpaEo1_45D303vUMeta } from "/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexnT1X_nbvq4Lro2KlcShZhRBRBNlt_oknfhM868aBFWkMeta } from "/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93otx7NEqj93fIhfOp27LiK1CBotoHhFXkbcjVKIgMEIAMeta } from "/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexTeB2GmOlffWFl0NOgdgGvCCLEn9aUnSQn1mHq7akkhkMeta } from "/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93fhq6OTUaO_45Vyq_ISwKzhx1wnAiqwyj621i12_or01ZUMeta } from "/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index_VG3KcjULAdBPo98SymP9ew60_45UsSBbekiS_E1b1DTcMeta } from "/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index09c_NDMXTNqzf7uu8acMi1aOTiLRNPmrnqETSzjXwhMMeta } from "/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexnT1X_nbvq4Lro2KlcShZhRBRBNlt_oknfhM868aBFWkMeta || {},
    component: () => import("/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexTeB2GmOlffWFl0NOgdgGvCCLEn9aUnSQn1mHq7akkhkMeta || {},
    component: () => import("/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index_VG3KcjULAdBPo98SymP9ew60_45UsSBbekiS_E1b1DTcMeta || {},
    component: () => import("/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index09c_NDMXTNqzf7uu8acMi1aOTiLRNPmrnqETSzjXwhMMeta || {},
    component: () => import("/codebuild/output/src4242880914/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]